'use client';

import {useMediaQuery} from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Desktop(props: any): JSX.Element | null {
  const matches = useMediaQuery('(min-width:1025px)');

  if (matches) return props.children;
  return null;
}
